import { render, staticRenderFns } from "./historagm.vue?vue&type=template&id=aca6055c&scoped=true"
import script from "./historagm.vue?vue&type=script&lang=js"
export * from "./historagm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca6055c",
  null
  
)

export default component.exports